var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vue-admin" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "page-space" }, [
      _c(
        "div",
        { staticClass: "ui secondary segment" },
        [
          _vm.error
            ? _c("error-display", { attrs: { error: _vm.error } })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "ui grid" }, [
            _c(
              "div",
              { staticClass: "eight wide column" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "ui small green button",
                    attrs: { to: "/admin/people/create" }
                  },
                  [
                    _c("i", { staticClass: "add user icon" }),
                    _vm._v(" Add Person\n                    ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "eight wide column" }, [
              _c("label", { attrs: { for: "filter" } }, [_vm._v("Filters")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter,
                    expression: "filter"
                  }
                ],
                attrs: { id: "filter" },
                domProps: { value: _vm.filter },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.filter = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("table", { staticClass: "ui small table segment" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.models, function(model) {
                return [model.last_name, model.first_name, model.title]
                  .join(",")
                  .toLowerCase()
                  .includes(_vm.filter.toLowerCase())
                  ? _c("tr", { key: model.id }, [
                      _c(
                        "td",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "ui mini button",
                              attrs: {
                                to: "/admin/people/" + model.id + "/edit"
                              }
                            },
                            [_vm._v("Edit")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("img", {
                          staticClass: "img-in-list",
                          attrs: {
                            alt: "default",
                            src: model.photo
                              ? model.photo.folder + "thumb_" + model.photo.file
                              : "/img/default.jpg?v=1"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(model.first_name) +
                            " " +
                            _vm._s(model.last_name)
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(model.location))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(model.title))])
                    ])
                  : _vm._e()
              })
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-banner" }, [
      _c("h1", [_vm._v("People — Admin")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Photo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Location")]),
        _vm._v(" "),
        _c("th", [_vm._v("Title")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17c1f969", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c1f969","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/admin/people/index.vue
// module id = 547
// module chunks = 0